const esc = value => String(value ?? '').replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#039;');
const num = value => Math.max(0, Number(value) || 0).toLocaleString('ru-RU');

/** An isolated preview; never applies a theme merely by opening it. */
export function createThemePreview(options) {
  const dialog = document.createElement('dialog');
  dialog.className = 'theme-preview-dialog';
  dialog.setAttribute('aria-labelledby', 'theme-preview-title');
  document.body.append(dialog);
  let currentId = '', mode = 'profile', busy = false, notice = '', opener;
  const purchased = new Set();
  function stopMedia() { dialog.querySelectorAll('video').forEach(video => { video.pause(); video.removeAttribute('src'); video.load(); }); }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  dialog.addEventListener('close', () => {
    stopMedia(); options.onClose?.();
    if (opener?.isConnected) opener.focus();
    else document.querySelector(`[data-theme-action="preview"][data-theme-id="${CSS.escape(currentId)}"]`)?.focus();
  });
  async function act(theme, owned) {
    if (busy) return;
    const balance = Math.max(0, Number(options.getUser().coins) || 0);
    if (!owned && balance < Number(theme.price || 0)) { close(); options.onTopUp(); return; }
    busy = true; notice = ''; render();
    try {
      if (owned) {
        await options.onApply(String(theme.id));
        notice = String(options.getMine().active_theme || '') === String(theme.id) ? 'Тема установлена на твой профиль' : 'Не удалось применить тему. Попробуй ещё раз';
      } else {
        const ok = await options.onBuy(String(theme.id));
        if (ok === true) { purchased.add(String(theme.id)); notice = 'Тема куплена. Теперь её можно применить'; }
        else notice = 'Покупка не выполнена. Проверь баланс и попробуй ещё раз';
      }
    } catch { notice = 'Не удалось выполнить действие. Попробуй ещё раз'; }
    finally { busy = false; if (dialog.open) { render(); dialog.querySelector('[data-preview-action]')?.focus(); } }
  }
  function render() {
    const theme = options.getTheme(currentId); if (!theme) return close();
    const user = options.getUser(), mine = options.getMine();
    const owned = purchased.has(currentId) || (mine.owned || []).map(String).includes(currentId) || String(theme.author_id || '') === String(options.getUserId() || '__guest');
    const active = String(mine.active_theme || '') === currentId;
    const balance = Math.max(0, Number(user.coins) || 0), price = Math.max(0, Number(theme.price) || 0);
    const affordable = balance >= price;
    const avatar = document.querySelector('#av-img')?.getAttribute('src');
    stopMedia();
    dialog.innerHTML = `<div class="theme-preview-shell">
      <header class="theme-preview-header"><div><h2 id="theme-preview-title">${esc(theme.title || 'Тема профиля')}</h2><p>${esc(theme.author_name || 'Автор темы')}</p></div><button type="button" data-preview-close aria-label="Закрыть просмотр">×</button></header>
      <div class="theme-preview-modes" role="group" aria-label="Режим просмотра"><button type="button" data-preview-mode="profile" aria-pressed="${mode==='profile'}">На профиле</button><button type="button" data-preview-mode="art" aria-pressed="${mode==='art'}">Изображение</button></div>
      <div class="theme-preview-stage ${mode==='art'?'is-art':''}">
        <div class="theme-preview-media">${options.renderMedia(theme,{eager:true})}</div>
        ${mode==='profile'?`<div class="theme-preview-account"><div class="theme-preview-identity"><span class="theme-preview-avatar">${avatar?`<img src="${esc(avatar)}" alt="">`:esc(String(user.name || 'R').slice(0,1))}</span><strong>${esc(user.name || 'Игрок')}</strong></div><p>${esc(user.universe || 'Твоя вселенная')}</p><div><span>Очки <b>${num(user.pts)}</b></span><span>${esc(typeof user.league==='string'?user.league:'')}</span></div></div>`:''}
      </div>
      <div class="theme-preview-purchase"><div class="theme-preview-price"><span>${owned?'В твоей коллекции':'Стоимость темы'}</span><strong>${owned?(active?'Установлена':'Куплена'):`${num(price)} <small>рекоинов</small>`}</strong></div>
      <p class="theme-preview-balance">${owned?'Оформление можно сменить в любое время':`Твой баланс: ${num(balance)} рекоинов${affordable?'':` · Не хватает ${num(price-balance)}`}`}</p>
      <button class="theme-preview-primary" type="button" data-preview-action ${busy||active?'disabled':''}>${busy?'Подождите…':active?'Установлена':owned?'Применить тему':affordable?`Купить за ${num(price)} рекоинов`:'Пополнить баланс'}</button>
      <p class="theme-preview-notice" role="status">${esc(notice)}</p></div></div>`;
    dialog.querySelector('[data-preview-close]').addEventListener('click',close);
    dialog.querySelectorAll('[data-preview-mode]').forEach(button=>button.addEventListener('click',()=>{mode=button.dataset.previewMode;render();dialog.querySelector(`[data-preview-mode="${mode}"]`)?.focus();}));
    dialog.querySelector('[data-preview-action]').addEventListener('click',()=>act(theme,owned));
    dialog.querySelectorAll('video').forEach(video=>{
      video.controls=true; video.classList.remove('is-loading'); video.preload='metadata';
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) video.play()?.catch(()=>{});
    });
  }
  return {
    open(id) {
      if (!options.getTheme(id)) return;
      opener=document.activeElement;currentId=String(id);mode='profile';notice='';render();
      document.querySelectorAll('#theme-hub video').forEach(video=>video.pause());
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('[data-preview-close]')?.focus();
    }, close,
  };
}
